import { render, staticRenderFns } from "./add_addres.vue?vue&type=template&id=e6509450&scoped=true"
import script from "./add_addres.vue?vue&type=script&lang=js"
export * from "./add_addres.vue?vue&type=script&lang=js"
import style0 from "./add_addres.vue?vue&type=style&index=0&id=e6509450&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6509450",
  null
  
)

export default component.exports